/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Settings section header
 *
 * @author Satyaki Bose
 * @file SettingsSectionHeader.jsx
 */

import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@mui/material';
import Icon from '../../icons/Icon';

const SettingsSectionHeader = ({
  classes,
  title,
  showGradebookInfoButton,
  onInfoClick,
  infoButtonAriaLabel
}) => (
  <div className={classes.sectionHeader}>
    <div className={classes.sectionTitleGroup}>
      <h2 className={classes.sectionTitle}>{title}</h2>
      {showGradebookInfoButton ? (
        <IconButton
          type="button"
          className={classes.infoButton}
          onClick={onInfoClick}
          aria-label={infoButtonAriaLabel}
        >
          <Icon name="InfoIcon" />
        </IconButton>
      ) : null}
    </div>
  </div>
);

SettingsSectionHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  showGradebookInfoButton: PropTypes.bool,
  onInfoClick: PropTypes.func,
  infoButtonAriaLabel: PropTypes.string
};

SettingsSectionHeader.defaultProps = {
  showGradebookInfoButton: false,
  onInfoClick: null,
  infoButtonAriaLabel: undefined
};

export default SettingsSectionHeader;
